'use strict';
import {epics as reduxListEpics} from '../redux';
import {epics as onSweepListEpics} from './onSweepList';
import {epics as onTogglePinEpics} from './onTogglePin';

export const epics = [
  ...reduxListEpics,
  ...onSweepListEpics,
  ...onTogglePinEpics,
];



// WEBPACK FOOTER //
// ./src/js/priorities/epics/index.js